
export const environment = {
  env: 'tpc',
  production: false,
  oidc: {
    clientId: '0oa9o137yfep8EfUx4h7',
    issuer: 'https://relayhealth.okta.com/oauth2/aus95ynd1xJvRSJ8N4h7',
    redirectUri: 'login/callback',
    scopes: ['openid'],
    pkce: false
  },
  authPrefix: 'NPE-TPC',
  authGroup: 'SmartHopUI-Users',
  appUrl: 'https://smarthop-config-tpc.relayhealth.com',
  apiUrl: 'https://smarthop-config-api-tpc.relayhealth.com'
};
